import { Link } from 'react-router-dom';

const VARIANTS = {
  primary: 'bg-brand text-white hover:bg-brand-dark shadow-[0_6px_16px_rgba(232,55,74,0.3)]',
  secondary: 'bg-panel text-ink hover:bg-brand hover:text-white',
  ghost: 'border-[1.5px] border-ink text-ink hover:bg-ink hover:text-white',
  dark: 'bg-ink text-white hover:bg-black'
};

const SIZES = {
  sm: 'px-4 py-2 text-[13px]',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-7 py-3.5 text-[15px]'
};

const BASE = 'inline-flex items-center justify-center gap-2 rounded-full font-bold transition-colors disabled:opacity-50 disabled:pointer-events-none';

export default function Button({
  variant = 'primary', size = 'md', to, type = 'button', className = '', children, ...rest
}) {
  const classes = `${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} {...rest}>{children}</Link>;
  }
  return <button type={type} className={classes} {...rest}>{children}</button>;
}
